export default __webpack_public_path__ + "static/media/floating-solution-tube-rack-empty.4e53c15b.svg";